import { computed, Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../../modules/shared/store/common/component-store-v2.factory';
import { FilterBuilder } from '../../../../../modules/content/helper/filter.builder';
import { getRulesFrag } from './select-user-rule.query';
import { allowedActions, ResourceEnum } from '../../../../../../../../types/src/authorization/enum/resource.enum';
import { translate } from '../../../../../modules/shared/shared.global-service';

export const JOIN_KEY = ' :: ';

export function ruleId(resource: string, action: string): string {
    return `${resource}${JOIN_KEY}${action}`;
}

export function parseRuleId(rule: string) {
    const [resource, action] = rule.split(JOIN_KEY);
    return { resource, action };
}

@Injectable()
export class SelectUserRuleStore extends ComponentStoreV2Factory {

    public rules = computed(() => {
        return Object.values(ResourceEnum).flatMap((resource) => {
            return allowedActions(resource).map((action) => {
                if (this.isAllowed(`${resource}.${action}`)() || this.isAllowedGlobal('rule.update')()) {
                    return {
                        id: ruleId(resource, action),
                        name: `${translate.instant(`acl.group.resource.${resource}`)}${JOIN_KEY}${translate.instant(`acl.group.action.${action}`)}`,
                    };
                }
                return null;
            });

        })
            .filter((it) => it);
    });

    constructor() {
        super();
        this.api.getRules(FilterBuilder.singlePage({}), getRulesFrag).then();
    }


}
